import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { captureUtm } from "@/utils/utm";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import Quote from "@/pages/Quote";
import NotFound from "@/pages/NotFound";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-amber border-t-transparent" data-testid="auth-loading" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  useEffect(() => {
    captureUtm();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          <Route path="/devis" element={<Quote />} />
          <Route path="/devis/:product" element={<Quote />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}
